import { CancelToken } from "axios";
import { PDADataService } from "../../../services/base/PDADataService";
import { PagedList } from "../../../types/dataQueries/base/PagedList";
import { CWContractor } from "../models/CWContractor";
import {CWContractorSearchRequest} from "../models/CWContractorSearchRequest";
export class ContractorsService extends PDADataService{
  protected prefixUrl: string = `Contractors`;
  
  SearchBriefPaged(query: CWContractorSearchRequest, cancelToken?: CancelToken) {
    
    return this.api.get<PagedList<CWContractor>>(
      `${this.prefixUrl}/SearchBriefPaged?query=${encodeURIComponent(JSON.stringify(query))}`, {cancelToken}
    );
  }

  GetBriefById(id: number){
    return this.api.get<CWContractor>(`${this.prefixUrl}/GetBriefById?id=${id}`);
  }
}
